import React from 'react';
import greenBg from '../assets/g-bg.svg';
import blueBg from '../assets/b-bg.svg';
import yellowBg from '../assets/y-bg.svg';
import purpleBg from '../assets/p-bg.svg';
import loader from '../assets/loader.svg';
import play from '../assets/play.svg';
import Modal from './modal/Modal';
import Video from './VideoPlayer/Video';
import moment from 'moment';
import { Link, Redirect } from 'react-router-dom';
import {baseUrl} from './url';

const GreenBg = {
    background: `url(${greenBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
}
const BlueBg = {
    background: `url(${blueBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
}
const YellowBg = {
    background: `url(${yellowBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
}
const PurpleBg = {
    background: `url(${purpleBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
}

class Dashboard extends React.Component{
    constructor(){
        super()
        this.state = { 
            show: false,
            summaries: [],
            vots: [],
            patients: [],
            appointments: [],
            caregivers: [],
            response: false
        }
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.showUser = this.showUser.bind(this);
        this.passUserType = this.passUserType.bind(this);
    }
    componentWillMount(){
        const token = localStorage.getItem('access_token');
        let retries = 0;
        fetch(`${baseUrl}/admin`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            if(response.status === 403){
                localStorage.removeItem('access_token');
                return <Redirect to='/login' />
            }
            return response.json();
        })
        .then((responseJson) => {
            console.log(responseJson);
            this.setState({
                summaries: responseJson.data.summary,
                vots: responseJson.data.vots || [],
                patients: responseJson.data.patients || [],
                appointments: responseJson.data.appointments || [],
                caregivers: responseJson.data.caregivers || [],
                response: true
            })
        })
        .catch((error)=>{
            console.log(error);
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        console.log(response);
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    showModal(id){
        this.setState({ videoId: id, show: true });
    };
    hideModal(){
        this.setState({ show: false });
    };
    showUser(id, type){
        if(type === 'caregiver'){
            localStorage.setItem('user_type','care_giver');
        }else{
            localStorage.setItem('user_type',type);
        }
        localStorage.setItem('user_id', id);
        this.props.history.push(`/${type}`);
    };
    passUserType(type){
        localStorage.setItem('all_users_type', type)
    }
    render(){
        return(
            <div className="dashboard">
                <div className="container-fluid">
                    <h3 className="page-title">Dashboard</h3>
                    {
                        !this.state.response &&
                        <div className="loader">
                            <img src={loader} alt=""/>
                        </div>
                    }
                    {
                        this.state.response &&
                        <div>
                            <div className="row mobile-row">
                                {this.state.summaries.map((summary, index) => {
                                    let id = summary.id;
                                    let style,shouldClick,users, link;
                                    if (id === 'appointments'){
                                        style = GreenBg;
                                        link = '/';
                                    }
                                    if (id === 'patients'){
                                        style = BlueBg;
                                        users = 'patient';
                                        shouldClick = true;
                                        link = '/users';
                                    }
                                    if (id === 'caregivers'){
                                        style = YellowBg;
                                        users = 'caregiver'
                                        shouldClick = true;
                                        link = '/users';
                                    }
                                    if (id === 'vots'){
                                        style = PurpleBg;
                                        link = '/submissions';
                                    }
                                    return(
                                        <div key={index} className="col-md-3 col-6">
                                            <Link
                                                style={{ textDecoration: 'none' }}
                                                to={link}
                                            >
                                                <div className="cards" 
                                                    onClick={() => {shouldClick && this.passUserType(users)}}
                                                    style={style}>
                                                    {
                                                        id === 'vots'?
                                                        <h5>vDots</h5>
                                                        :
                                                        <h5>{id.charAt(0).toUpperCase() + id.slice(1)}</h5>
                                                    }
                                                    <h2>{summary.total || 0}</h2>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-8">
                                    <div className="vot-sub section-card">
                                        <div className="card-title vot-title">
                                            <h3>Recent vDOT Submissions</h3>
                                        </div>
                                        {
                                            this.state.vots.length > 0?
                                            <div>
                                                <table>
                                                    <tbody>
                                                        {this.state.vots.map(vot => {
                                                            let time = moment(vot.time).format('dddd h:mmA');
                                                            // const { video_url } = vot;
                                                            return(
                                                                <tr key={vot.id}>
                                                                    <td>
                                                                        <div className="play-div" onClick={() => this.showModal(vot.id)}><img src={play} alt=""/></div>
                                                                        {/* {video_url && <div className="play-div" onClick={() => this.showModal(vot.id)}><img src={play} alt=""/></div>} */}
                                                                        {/* {!video_url && <img src={noVid} alt="" onClick={() => this.showModal(vot.id)}/>} */}
                                                                    </td>
                                                                    <td><h4 className="name">{vot.name}</h4></td>
                                                                    <td><h4 className="alias">{vot.username}</h4></td>
                                                                    <td><h4 className="time">{time}</h4></td>
                                                                    <td><button className="btn btn-view-history" onClick={() => this.showModal(vot.id)}>View submission</button></td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                                <Modal show={this.state.show} handleClose={this.hideModal}>
                                                    {this.state.show && <Video videoId={this.state.videoId}/>}
                                                </Modal>
                                                <div className="view-all">
                                                    <Link to="/submissions"><button className="btn btn-view-all">View all</button></Link>
                                                </div>
                                            </div>
                                            :
                                            <div className="view-all">
                                                <p>No vDots submitted yet.</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-4">
                                    <div className="recently-added section-card">
                                        <div className="card-title recently-title">
                                            <h3>Recently Added Patients</h3>
                                        </div>
                                        {
                                            this.state.patients.length > 0?
                                            <div>
                                                <table>
                                                    <tbody>
                                                        {this.state.patients.map(patient => {
                                                            let date = moment().format('YYYY-MM-DD'),
                                                                t_time = moment(`${date} ${patient.treatment_time}`).format('h:mmA'),
                                                                name = patient.name,
                                                                matches = name.match(/\b(\w)/g),
                                                                nameBadge = matches.join('').toUpperCase(),
                                                                id = JSON.parse(patient.id);
                                                            return(
                                                                <tr key={id} onClick={ () => this.showUser(id, 'patient')}>
                                                                    <td className="name-badge">
                                                                        <div className="name-icon">
                                                                            <h4>{nameBadge}</h4>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <h4 className="name">{patient.name}</h4>
                                                                        <p className="time">Treatment Time - {t_time}</p>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                                <div className="view-all">
                                                    <Link to='/users'><button className="btn btn-view-all" onClick={() => this.passUserType("patient")}>View all</button></Link>
                                                </div>
                                            </div>
                                            :
                                            <div className="view-all">
                                                <p>No patient has been added.</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-8">
                                    <div className="upcoming-appoint section-card">
                                        <div className="card-title appointment-title">
                                            <h3>Upcoming Appointments</h3>
                                        </div>
                                        {
                                            this.state.appointments.length > 0?
                                            <div>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <th>Patient Name</th>
                                                            <th>Caregiver</th>
                                                            <th>Date</th>
                                                            <th>Time</th>
                                                        </tr>
                                                        {this.state.appointments.map(appointment => {
                                                            let time = moment(appointment.time).format('h:mmA');
                                                            let date = moment(appointment.time).format('DD/MM/YYYY');
                                                            return(
                                                                <tr key={appointment.id}>
                                                                    <td>{appointment.name} ({appointment.username})</td>
                                                                    <td>{appointment.caregiver}</td>
                                                                    <td>{date}</td>
                                                                    <td>{time}</td>
                                                                </tr> 
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                                <div className="view-all">
                                                    <button className="btn btn-view-all">View all</button>
                                                </div>
                                            </div>
                                            :
                                            <div className="view-all">
                                                <p>No Appointment has been created yet.</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-4">
                                    <div className="caregivers section-card">
                                        <div className="card-title caregivers-title">
                                            <h3>Caregivers</h3>
                                        </div>
                                        {
                                            this.state.caregivers.length > 0?
                                            <div>
                                                <table>
                                                    <tbody>
                                                        {this.state.caregivers.map(caregiver => {
                                                            let name = caregiver.name,
                                                                matches = name.match(/\b(\w)/g),
                                                                nameBadge = matches.join('').toUpperCase(),
                                                                id = JSON.parse(caregiver.id);
                                                            return(
                                                                <tr key={id} onClick={ () => this.showUser(id, 'caregiver')}>
                                                                    <td className="name-badge">
                                                                        <div className="name-icon">
                                                                            <h4>{nameBadge}</h4>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <h4 className="name">{caregiver.name}</h4>
                                                                        <p className="patients">{caregiver.total} Patients assigned</p>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                                <div className="view-all">
                                                    <Link to='/users'><button className="btn btn-view-all" onClick={() => this.passUserType("caregiver")}>View all</button></Link>
                                                </div>
                                            </div>
                                            :
                                            <div className="view-all">
                                                <p>No caregiver has been added.</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard.js